export default "__VITE_ASSET__H2TiJvLo__"